import React, { Component } from 'react'
import { Link } from "react-router-dom";
import { Row } from 'reactstrap';
import PropTypes from 'prop-types'



export class CategoryTree extends Component {
    state = {
    }

    componentDidMount() {

    }

    render() {
        return (
            <div>
                <div>
                    <div className="clearfix mt-2">
                        <a onClick={this.props.addCategory(this.props.model.Id, this.props.model.Name)}>{this.props.model.Name}</a>
                        {
                            this.props.model.HasChildren && (
                                <a className={`float-right ${this.props.open ? 'minus' : 'plus'}`} onClick={this.toggle}></a>
                                )
                        }
                    </div>
                    {
                        this.props.model.HasChildren && (
                            <div className={`templates-children mt-1 ${this.props.open ? 'show' : 'hidden'}`}>
                                {
                                    this.props.model.Children.map(item => (
                                        <CategoryTree className="item" model={item.Children} addCategory={this.props.addCategory}></CategoryTree>
                                        ))
                                }
                    </div >
                                )
                            }
        
        </div >
    </div >
        )
    }
}

export default CategoryTree